import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { PermissionsService } from '../../../services/permission.service';

@Component({
  selector: 'app-kmp',
  standalone: false,
  templateUrl: './kmp.component.html',
  styleUrl: './kmp.component.scss'
})
export class KmpComponent implements OnInit, OnDestroy {
  title = 'General Legal Policy / Charter Duties';
  kmpData: any[] = [];
  kmpForm: FormGroup;
  cols: any[] = [
    { field: 'scheme_names', header: 'Scheme Name', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'name', header: 'File Name', filterType: 'text', width: '120px', minWidth: '100px', maxWidth: '150px' },
    { field: 'reference_document_remark', header: 'Document Remark', filterType: 'text', width: '200px', minWidth: '150px', maxWidth: '300px' },
    // { field: 'scheme.name', header: 'Scheme' },
    { field: 'document', header: 'Document', type: 'link', width: '40px', minWidth: '40px', maxWidth: '150px' },

  ];
  file: File[] = [];
  isDialogVisible: boolean = false;
  kmp: any[];
  selectedSchemeId: any;
  schemes: any;
  uploadedFilePath: any;
  showDeleteDialog: boolean = false;
  selectedKMP: any;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  private subscriptions = new Subscription();
  constructor(private fb: FormBuilder, private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) {
    this.kmpForm = this.fb.group({
      scheme: [[], Validators.required],
      reference_document_remark: ['', Validators.required],
      name: [''],

    });
  }


  ngOnInit(): void {
    this.getAllKmp();
    this.getSchemeList();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  totalRecords: number = 0;
  getAllKmp(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/kmp/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      this.kmpData = res.results || res.data;
      this.totalRecords = res.count || 0
    });
    this.subscriptions.add(sub);
  }
  onAdd(type: string, rowData?: any) {
    this.viewMode = false;
    this.isDialogVisible = true;
    this.kmpForm.enable()
    if (type === 'add') {
      this.kmpForm.reset({
        scheme: null,
        reference_document_remark: '',
        document: '',
        name: ''
      });
      this.uploadedFilePath = null
      this.file = [];
    }
   
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  onFileChange(event: any, fileField: 'file1' | 'file2') {
    const inputEl = event.target as HTMLInputElement;
    const selectedFiles = Array.from(inputEl?.files || []);

    if (fileField === 'file1') {
      this.file = selectedFiles;
    }

    const firstFile = selectedFiles[0];
    if (firstFile) {
      this.kmpForm.get('document')?.setValue(firstFile.name);
      this.kmpForm.get('document')?.markAsDirty();
      this.kmpForm.get('document')?.markAsTouched();
    } else {
      this.kmpForm.get('document')?.reset();
    }
  }
 
  onSave() {
    const formData = new FormData();

    // formData.append('scheme', this.kmpForm.value.scheme);
    this.kmpForm.value.scheme.forEach((schemeItem) => formData.append('scheme', schemeItem));
    formData.append('reference_document_remark', this.kmpForm.value.reference_document_remark);
    formData.append('name', this.kmpForm.value.name || '');

    if (this.file?.length) {
      this.file.forEach((fileItem) => formData.append('document', fileItem));
    }
    if (this.selectedKMP) {
      const sub = this.api.putAPI(`/master/kmp/${this.selectedKMP.id}/`, formData).subscribe({
        next: (res: any) => {
          this.isDialogVisible = false;
          this.kmpForm.reset();
          this.file = [];
          this.uploadedFilePath = null;
          this.fileUpload?.clear();
          this.getAllKmp();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'KMP updated Successfully' // Fixed typo
          });
        },
        error: (err) => {
          console.error('Error:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error.message || 'Failed to save KMP'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI('/master/kmp/', formData).subscribe({
        next: (res: any) => {
          this.isDialogVisible = false;
          this.kmpForm.reset();
          this.file = [];
          this.getAllKmp();
          this.uploadedFilePath = null;
          this.fileUpload?.clear();
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'KMP Added Successfully'
          });
        },
        error: (err) => {
          console.error('Error:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error.message || 'Failed to save KMP'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  viewMode = false;
  viewSystem(rowData: any) {
    this.viewMode = true;
    if (rowData && rowData.id) {
      this.isDialogVisible = true;
      this.selectedKMP = rowData;
      this.kmpForm.patchValue({
        id: rowData.id,
        reference_document_remark: rowData.reference_document_remark,
        scheme: rowData.scheme?.id || '',
        document: rowData.document || '',
        name: rowData.name || ''
      });
      this.kmpForm.disable()
      this.uploadedFilePath = rowData.document || null;
      this.kmpForm.get('document')?.setValue(rowData.document);
    }
  }
  updateKMP(unit: any): void {
    if (unit) {
      this.viewMode = false;
      this.kmpForm.enable()
      this.isDialogVisible = true;
      this.selectedKMP = unit;
      this.file = [];
      this.kmpForm.patchValue({
        id: unit.id,
        reference_document_remark: unit.reference_document_remark,
        scheme: unit.scheme || '',
        document: unit.document || '',
        name: unit.name || ''
      });
      this.uploadedFilePath = unit.document || null;
      this.kmpForm.get('document')?.setValue(unit.document);
    } else {
      console.error('No equipment data provided for editing');
    }
  }
  getSchemeList() {
this.api.getAPI('/master/scheme/').subscribe((res: any) => {
      this.schemes = res;
    });

  }
  
  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedKMP = equipment
  }

  deleteSystem() {
    let sectionId = this.selectedKMP.id
    const sub = this.api.deleteAPI(`/master/kmp/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'KMP Deleted Successfully',
        });
        this.showDeleteDialog = false
        this.getAllKmp();
      },
      error: (err) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the Unit. Please try again.',
        });
      },
    });
    this.subscriptions.add(sub);
  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/kmp', 'Edit') ||
      this.permissionService.hasPrivilege('/master/kmp', 'Delete') ||
      this.permissionService.hasPrivilege('/master/kmp', 'View');
  }
}
